import { createRouter, createWebHistory } from 'vue-router'
import MainMs from '../views/MainMs.vue'
import infoOfPatient from '../views/InfoOfPatient.vue'
import infoOfContact from '../views/infoOfContact.vue'
import infoOfWorkers from '../views/infoOfWorkers.vue'
import infoOfSpecialist from '../views/infoOfSpecialist.vue'
import infoOfInstitution from '../views/infoOfInstitution.vue'
import infoOfDocuments from '../views/infoOfDocuments.vue'
import infoOfVacancies from '../views/infoOfVacancies.vue'
import commentMs from '../views/commentMs.vue'
import newsMs from '../views/newsMs.vue'
import loginAdmin from '../views/loginAdmin.vue'
import loginAdminUp from '../views/loginAdminUp.vue'
import searchMs from '../views/searchMs.vue'
import privatePolitic from '../views/PrivatePolitic.vue'
import infoOfCorruption from '../views/infoOfCorruption.vue'
import infoOfProcurement from '../views/infoOfProcurement.vue'
import infoOfOversight from '../views/infoOfOversight.vue'

import errorMs from '../components/errorMs.vue'

const routes = [
  {
    path: '/privatePolitic',
    name: 'Политика конфиденциальности',
    component:privatePolitic
  },
    {
    path: '/procurement',
    name: 'Закупки',
    component:infoOfProcurement
  },
  {
    path: '/oversight',
    name: 'Вышестоящие и контролирующие органы',
    component:infoOfOversight
  },
  {
    path: '/corruption',
    name: 'Противодействие коррупции',
    component:infoOfCorruption
  },
  {
    path: '/',
    name: 'Главнфя',
    component:MainMs
  },
  {
    path: '/searchMs',
    name: 'Поиск',
    component:searchMs
  },
  {
    path: '/infoOfPatient',
    name: 'Информация для пациентов',
    component:infoOfPatient,
    children: [
        { path: '/infoOfPatient/:path', name:'',component:errorMs }]
  },
  {
    path: '/contact',
    name: 'Контактная информация',
    component:infoOfContact
  },
  {
    path: '/workers',
    name: 'Медицинские работники',
    component:infoOfWorkers, 
    children: [
        { path: '/workers/person/:path', name:'',component:errorMs }]
  },
  {
    path: '/infoOfSpecialist',
    name: 'Информация для специалистов',
    component:infoOfSpecialist
  },
  {
    path: '/institution',
    name: 'Об учреждении',
    component:infoOfInstitution
  },
  {
    path: '/documents',
    name: 'Документы',
    component:infoOfDocuments
  },
  {
    path: '/vacancy',
    name: 'Вакансии',
    component:infoOfVacancies
  },
  {
    path: '/comment',
    name: 'Отзывы пациентов',
    component:commentMs
  },
  {
    path: '/news',
    name: 'Новости',
    component:newsMs,
       children: [
      { path: '/news/item/:path', name:'',component:errorMs }]
  },
  { 
    path: '/admin',
    name: 'Вход',
    component:loginAdmin
  },
  { 
    path: '/adminup',
    name: 'Изменить',
    component:loginAdminUp
  },
  {
    path: '/:pathMatch(.*)*', component: errorMs 
  }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
     console.log(to,'to')
    return new Promise((resolve) => {  
      setTimeout(() => {  
        
        let marginTop = 0
        let mainElement 
        if (to.hash) {
          mainElement = document.querySelector(to.hash)
        }
        if (mainElement) {
          marginTop = parseFloat(
            getComputedStyle(mainElement).scrollMarginTop
          )
         
        }
        if (to.hash) {
            // return ()
            resolve ({
                el: to.hash,
                top: marginTop,
            });
        } else if (savedPosition) {
            resolve (savedPosition);
        } else {
            resolve({ left: 0, top: 0 })  
        }
        
      }, 500)  
    }) 
  },
})

export default router
